import { Doughnut } from 'react-chartjs-2';
import React from 'react';
import { ArcElement, Chart as ChartJS } from 'chart.js';

import './chart.scss';

ChartJS.register(ArcElement);

interface IChartData {
    labels: Array<string>;
    datasets: Array<IChartDataset>;
}

interface IChartDataset {
    data: Array<number>;
    backgroundColor: Array<string>;
    cutout: string;
}

const Chart: React.FC<{ data: IChartData; product: string }> = ({
    data,
    product,
}) => {
    const total = data.datasets[0].data.reduce((p, c) => {
        return p + c;
    });
    return (
        <div className='status-summary-body_chart'>
            <Doughnut data={data}></Doughnut>
            <div className='status-summary-body_chart-title'>
                <span>{total}</span>
                <span>{product}</span>
            </div>
        </div>
    );
};

export default Chart;
